import {
  SET_UPLOAD_PAGE,
  SET_UPLOAD_PAGE_LOADING,
  SET_UPLOAD_PAGE_NOT_FOUND,
  SET_UPLOAD_PAGE_LOCKED,
  SET_UPLOAD_PAGE_DRAG_DROP_ENABLED,
  SET_UPLOAD_PAGE_ERROR,
  SET_UPLOAD_PAGE_BATCH_ID,
} from '../actions/UploadPages';

const initialState = {
  uploadPage: null,
  loading: true,
  notFound: false,
  locked: false,
  dragDropEnabled: true,
  error: null,
  uploadBatchId: Date.now(),
};

export const UploadPages = (state = initialState, action) => {
  switch (action.type) {
    case SET_UPLOAD_PAGE:
      return ({ ...state, uploadPage: action.uploadPage });

    case SET_UPLOAD_PAGE_LOADING:
      return ({ ...state, loading: action.loading });

    case SET_UPLOAD_PAGE_NOT_FOUND:
      return ({ ...state, notFound: action.notFound });

    case SET_UPLOAD_PAGE_LOCKED:
      return ({ ...state, locked: action.locked });

    case SET_UPLOAD_PAGE_DRAG_DROP_ENABLED:
      return ({ ...state, dragDropEnabled: action.dragDropEnabled });

    case SET_UPLOAD_PAGE_ERROR:
      return ({ ...state, error: action.error });

    case SET_UPLOAD_PAGE_BATCH_ID:
      return ({ ...state, uploadBatchId: Date.now() });

    default:
      return state;
  }
};
